import { Project } from '../team-apis/otterdam/project';
import { Step } from '../team-apis/otterdam/step';
import { Task } from '../team-apis/otterdam/task';

// Name these functions the same as their corresponding path helpers in rails.
// Organize them under the "resource" that has the same name as their rails
// controller.

//////////////////////////
// DraftSubmissionResource
//////////////////////////

export function createOrUpdateDraftSubmissionsPath() {
  return `/draft_submissions/create_or_update`;
}

//////////////////
// ProjectResource
//////////////////

export function projectPath(projectOrId: Project | number) {
  return `/projects/${getId(projectOrId)}`;
}

/////////////////
// SampleResource
/////////////////

export function viewTaskSamplingPortalPath(
  projectOrId: Project | number,
  sampleId: number,
) {
  return `${projectPath(projectOrId)}/samples/${sampleId}/view_task`;
}

/////////////////////
// SampleTaskResource
/////////////////////

export function sampleTaskPath(id: number) {
  return `/sample_tasks/${id}`;
}

///////////////
// StepResource
///////////////

function projectStepPath(
  projectOrId: Project | number,
  stepOrId: Step | number,
) {
  return `${projectPath(projectOrId)}/steps/${getId(stepOrId)}`;
}

export function stopWorkProjectStepPath(
  projectOrId: Project | number,
  stepOrId: Step | number,
) {
  return `${projectStepPath(projectOrId, stepOrId)}/stop_work`;
}

///////////////
// TaskResource
///////////////

export function projectTaskPath(
  projectOrId: Project | number,
  taskOrId: Task | string,
) {
  return `${projectTasksPath(projectOrId)}/${getId(taskOrId)}`;
}

function projectTasksPath(projectOrId: Project | number) {
  return `${projectPath(projectOrId)}/tasks`;
}

export function reserveProjectStepTasksPath(
  projectOrId: Project | number,
  stepOrId: Step | number,
) {
  return `${projectStepTasksPath(projectOrId, stepOrId)}/reserve`;
}

export function submitAnswerProjectStepTasksPath(
  projectOrId: Project | number,
  stepOrId: Step | number,
) {
  return `${projectStepTasksPath(projectOrId, stepOrId)}/submit_answer`;
}

function projectStepTasksPath(
  projectOrId: Project | number,
  stepOrId: Step | number,
) {
  return `${projectStepPath(projectOrId, stepOrId)}/tasks`;
}

////////////////
// TokenResource
////////////////

export function tokensPath() {
  return '/tokens';
}

///////////

export function absoluteFromRelativeUrl(path: string) {
  return `${window.location.protocol}//${window.location.host}${path}`;
}

function getId(objectOrId: { id: number | string } | number | string) {
  return objectOrId instanceof Object ? objectOrId.id : objectOrId;
}

/////////////////
// ProjectGroupResource
/////////////////

export function projectGroupPath(project: Project) {
  return `/clients/${project.client_id}/project_groups/${project.project_group_id}`;
}

// Do not add more paths to this path. Paths will be declared in the relevent
// ressource service file.
